import { render } from "./Detall.vue?vue&type=template&id=6d8171f6&scoped=true"
import script from "./Detall.vue?vue&type=script&lang=js"
export * from "./Detall.vue?vue&type=script&lang=js"

import "./Detall.vue?vue&type=style&index=0&id=6d8171f6&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8171f6"]])

export default __exports__